export const dataSectionIRPFFamilyOpts = {
  situacionFamiliar: {
    title: 'Situación Familiar',
    sections: {
      title: 'Estado civil',
      options: {
        married: {
          textLong:
            'Casado/a y no separado/a legalmente cuyo cónyuge no obtiene rentas superiores a 1.500 euros anuales, excluidas las exentas.',
          textShort: 'Casado/a',
          husband_id: '43869566F'
        },
        single: {
          textLong:
            'Soltero/a, viudo/a, divorciado/a o separado/a legalment  e con hijos solteros menores de 18 años o incapacitados judicialmente que conviven exclusivamente con Vd. sin convivir también con el otro progenitor, siempre que proceda',
          textShort: 'Soltero/a'
        },
        others: {
          textLong:
            'Situación familiar distinta de las dos anteriores (solteros sin hijos, casados cuyo cónyuge obtiene rentas superiores a 1.500 euros anuales, ... etc).',
          textShort: 'Otras/No desea manifestarla',
          selected: true
        }
      }
    }
  },
  conyuge: {
    title: 'NIF cónyuge',
    textLong:
      'N.I.F. del cónyuge (si ha marcado la casilla 2, deberá consignar en esta casilla el N.I.F. de su cónyuge).',
    conyuge_id: '43869566F'
  },
  movilidadGeografica: {
    title: 'Movilidad geográfica',
    textLong:
      'Anteriormente estaba Vd. en situación de desempleo y la aceptación del puesto de trabajo actual ha exigido el traslado de su residencia habitual a un nuevo municipio.',
    date: null
  },
  prolongacionActividad: {
    title: 'PROLONGACIÓN DE LA ACTIVIDAD LABORAL',
    textLong:
      'Si una vez cumplidos los 65 años de edad, continúa o prolonga Vd. la actividad laboral, marque esta casilla.',
    selected: false
  },
  vivienda: {
    title:
      'Pagos por la adquisición o rehabilitación de la vivienda habitual utilizando financiación ajena, con derecho a deducción en el IRPF',
    textLong:
      'Importante: sólo podrán cumplimentar este apartado los contribuyentes que hayan adquirido su vivienda habitual, o hayan satisfecho cantidades por obras de rehabilitación de la misma, antes del 1 de enero de 2013. Si está usted',
    selected: false
  }
};

export const IRPFDataTxts = {
  breadcrumb: {
    first: 'Mis datos',
    second: 'Solicitar cambio de datos IRPF'
  },
  resume: {
    titleFamily: 'SITUACIÓN FAMILIAR ACTUAL',
    titleChilds:
      'Hijos y otros descendientes menores de 25 años, o mayores si son discapacitados, que conviven con el perceptor',
    titleParents:
      'Ascendientes mayores de 65 años, o menores si son discapacitados, que conviven con el perceptor',
    btn: 'SOLICITAR CAMBIO',
    backBtn: 'VOLVER'
  },
  edit: {
    titleFamily: 'SITUACIÓN FAMILIAR',
    btn: 'ENVIAR SOLICITUD',
    familyOpts: []
  },
  confirm: {
    title: 'TU SOLICITUD DE CAMBIO DE IRPF HA SIDO ENVIADA',
    txt: 'En breve te confirmaremos la actualización de los datos.',
    btn: 'Volver a mis datos'
  },
  pending: {
    irpf: 'Tienes una solicitud de cambio de IRPF pendiente de validar',
    DESCENDANT:
      'Tienes una solicitud de cambio de descendiente pendiente de validar',
    ASCENDANT:
      'Tienes una solicitud de cambio de ascendiente pendiente de validar'
  },
  label: {
    estadoCivil: 'Estado civil',
    nifConyuge: 'NIF cónyuge',
    movilidadGeo: 'Movilidad geográfica',
    prolongacionActividad: 'Prolongación de la actividad laboral',
    pais: 'País',
    pagosVivienda:
      'Pagos por la adquisición o rehabilitación de la vivienda habitual utilizando financiación ajena, con derecho a deducción en el IRPF'
  }
};

export const AscendantsTxts = {
  titleButton:
    'ASCENDIENTES MAYORES DE 65 AÑOS, O MENORES SI SON DISCAPACITADOS, QUE CONVIVEN CON EL PERCEPTOR',
  legend:
    'Si algún ascendiente convive también, al menos durante la mitad del año, con otros descendientes del mismo grado, indique en esta casilla el número total de descendientes con los que convive, incluso ud. (si los ascendentes sólo conviven con ud. no rellene esta casilla).'
};

export const DescendantsTxts = {
  titleButton:
    'HIJOS Y OTROS DESCENDIENTES MENORES DE 25 AÑOS, O MAYORES SI SON DISCAPACITADOS, QUE CONVIVEN CON EL PERCEPTOR',
  firstLegend:
    'Solamente en el caso de hijos adoptados o de menores acogidos. Tratándose de hijos adoptados que previamente hubieran estado acogidos, indique únicamente el año de acogimiento.',
  secondLegend:
    'En el caso de hijos que convivan únicamente con ud. sin convivir también con el otro progenitor (padre o madre) o de nietos que convivan únicamente con ud., sin convivir con ningún otro de sus abuelos.'
};
